/*Use this for newer act-on forms that use JS*/





import React from "react"

function newScript(id){
  var text =
  ` ! function(o, t, e, a) {
            o._aoForms = o._aoForms || [], o._aoForms.push(a);
            var n = function() {
              var o = t.createElement(e);
              true ? typeof(_aoFormLoader) != "undefined" ? _aoFormLoader.load({
                id: "` +
        id +
        `:d-0001",
                accountId: "36273",
                domain: "marketing.circadence.com",
                isTemp: false,
                noStyle: false,
                prefill: false
              }) : "" : n.insertBefore(o, a)
            };
            window.attachEvent ? window.attachEvent("onload", n) : window.addEventListener("load", n, !1), n()
          }(window, document, "script", {
            id: "` +
        id +
        `",
            accountId: "36273",
            domain: "marketing.circadence.com",
            isTemp: false,
            noStyle: false,
            prefill: false
          });
          `
  return text
}

export default class ActOnNew extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      loaded: false,
      formID: this.props.id,
    }
  }

  componentDidMount () {

    try {
      const head = document.querySelector("head")
      const remoteScript = document.createElement("script")

      remoteScript.setAttribute(
        "src",
        "https://marketing.circadence.com/acton/content/form_embed.js"
      )

      remoteScript.onload = function () {

        this.setState({
          loaded: true
        }, () => {

          const script = document.createElement("script");
          script.id="aoform-script-"+this.props.id+":d-0001"
          script.text = newScript(this.props.id);
          script.async = true;
          const wrapper = document.getElementById("act-on-form-wrapper"+this.props.id);
          wrapper.appendChild(script);

        })

      }.bind(this)

      head.appendChild(remoteScript)

    } catch {

    }


    // const script = document.createElement("script");
    // script.id="aoform-script-"+this.props.id+":d-0001"
    // script.text = newScript(this.props.id);
    // script.async = true;
    // const wrapper = document.getElementById("act-on-form-wrapper");
    // wrapper.appendChild(script);
}

  render() {
    return (
      <div>
        {(!this.state.loaded ? <div id="form-loading-wheel" class="lds-dual-ring">Loading form...</div> : <div/>)}
        <div id={"act-on-form-wrapper"+this.props.id}></div>
      </div>
    )
  }
}





/*
import React from "react"



function handleURL() {

  const refURL = document.getElementsByName("ao_refurl")[0]

  console.log(document.getElementById("aoform-8f7c089e-64ee-49c3-b6d0-33b0ab468ccd"), refURL);
  refURL != undefined && (refURL.value = "https://circadence.com/")
}

export default class ActOnNew extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      loaded: false,
      formID: this.props.id,
    }
  }

  componentDidMount() {

    try {

      const head = document.querySelector("head")

      const script = document.createElement("script")

      const script2 = document.createElement("script")


      script.setAttribute(
        "src",
        "https://marketing.circadence.com/acton/content/form_embed.js"
      )

      script.setAttribute("id", "aoloader")

      script.onload = function () {

        this.setState({
          loaded: true
        }, () => {
          this.new_script(this.state.formID)
        })

      }.bind(this)

      head.appendChild(script)
    } catch {
      console.log("No DOCUMENT on build")
    }
  }

  render() {
    return (
      <div>
        {(!this.state.loaded ? <div id="form-loading-wheel" class="lds-dual-ring">Loading form...</div> : <div/>)}
        <script id={"aoform-script-" + this.state.formID + ":d-0001"} />
      </div>
    )
  }
}
*/
